mutation SupplierDelete($input: SupplierDeleteInput!) {
  supplierDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
